import { useMutation } from '@tanstack/react-query';

import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

interface UpdateSelectedVendorsDto {
  searchId: string;
  selectedVendors: string[];
}

interface UpdateSelectedVendorsResponse {
  success: boolean;
  data: {
    id: string;
    user_id: string | null;
    search_query: string;
    selected_vendors: string[] | null;
    created_at: string;
    updated_at: string;
  };
}

export const useUpdateSelectedVendors = () => {
  const { session } = useAuth();

  return useMutation({
    mutationFn: async ({ searchId, selectedVendors }: UpdateSelectedVendorsDto) =>
      handleApiCall<UpdateSelectedVendorsResponse, { selectedVendors: string[] }>(
        session,
        'PUT',
        `vendor/search/${searchId}/selected-vendors`,
        { selectedVendors }
      ),
  });
};